import { createFileRoute } from "@tanstack/react-router";
import { FileText } from "lucide-react";

import { EmptyState } from "~/components/ui/empty-state";
import { Skeleton } from "~/components/ui/skeleton";
import { useAllEngagementSessionsByClient } from "~/lib/queries/sessionQuery";

import { CoachSessionNotes } from "./-components/coach-session-notes";
import { UserSessionNotes } from "./-components/user-session-notes";

export const Route = createFileRoute("/_user/coaching/$engagementId/notes")({
  staticData: { title: "Notes" },
  component: RouteComponent,
});

function RouteComponent() {
  const { engagementId } = Route.useParams();

  const { data: sessionData, isLoading } =
    useAllEngagementSessionsByClient(engagementId);

  const completedSessions =
    sessionData?.sessions.filter((s) => s.isCompleted) ?? [];

  if (isLoading) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-6 w-32" />
        <Skeleton className="h-32 w-full rounded-lg" />
        <Skeleton className="h-32 w-full rounded-lg" />
      </div>
    );
  }

  if (completedSessions.length === 0) {
    return (
      <EmptyState
        size="lg"
        icon={FileText}
        title="No notes yet"
        description="Once you complete a session, the notes you and your coach capture will appear here."
      />
    );
  }

  return (
    <div className="space-y-6">
      {completedSessions.map((session) => (
        <div key={session.id} className="space-y-3">
          <h3 className="font-heading text-lg font-medium text-gray-900">
            Session {session.sessionNumber}
            {session.goalDescription && (
              <span className="text-text-secondary ml-2 text-sm font-normal">
                — {session.goalDescription}
              </span>
            )}
          </h3>
          <UserSessionNotes sessionId={session.id} />
          <CoachSessionNotes sessionId={session.id} />
        </div>
      ))}
    </div>
  );
}
